export default __webpack_public_path__ + "static/media/logo1.f87a3bf6.png";